import SubmitButton from './SubmitButton';
import AddButton from './AddButton';
import { CopyButton, MoveDownButton, MoveUpButton, RemoveButton } from './IconButton';
function buttonTemplates() {
    return {
        SubmitButton,
        AddButton,
        CopyButton,
        MoveDownButton,
        MoveUpButton,
        RemoveButton,
    };
}
export default buttonTemplates;
//# sourceMappingURL=index.js.map